import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { connect } from 'react-redux';
import { FieldArray, reduxForm } from 'redux-form';

import Typography from '@material-ui/core/Typography';

import { DEFAULT_LANGUAGE } from 'pages/create-activity/constants';

import {
  ExpansionPanelWrapper,
  FormActionButtons,
  AddOnsFields
} from 'components';

import { deleteAddOns } from 'actions/activityAndAccommodation';

import validate from './validate';

import { useStyles } from './styles';

const initialValues = {
  addOns: []
};

const AddOns = ({ handleSubmit, setSubmitButton, isUpdate, actionLabel, ...otherProps}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [t] = useTranslation();

  const { languages, selectedLanguage, deleteAddOns, addOnsForm } = otherProps;

  const getTitle = item => {
    if (selectedLanguage !== DEFAULT_LANGUAGE) {
      if (item[selectedLanguage]) return item[selectedLanguage].title;
      return '';
    }
    return item.title;
  };

  const onAddHandler = (fields, id) => {
    const { languages } = otherProps;
    const languagesLength = languages.length;
    const secondLanguage = languages[languagesLength - 1];

    let data = {
      id: id,
      title: '',
      description: '',
      coverPhoto: '',
      USD: '0',
      EUR: '0',
      NOK: '0'
    };

    if (languagesLength > 1) {
      data[secondLanguage] = {
        title: '',
        description: ''
      };
    }

    fields.push(data);
  };

  const onDeleteHandler = item => {
    if (item.isCreated) deleteAddOns(item.id);
  };

  const handleSubmitWrapper = props => {
    if (languages.length > 1) {
      const errors = validate(addOnsForm.values, otherProps);

      if (Object.keys(errors).length) {
        enqueueSnackbar(
          t(
            'Please fill in all the required fields correctly on the current step for all languages'
          ),
          {
            variant: 'warning'
          }
        );
      }
    }
    handleSubmit(props);
  };

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('Add-ons')}
      </Typography>

      <form onSubmit={handleSubmitWrapper}>
        <FieldArray  
          name="addOns"
          component={ExpansionPanelWrapper}
          isAddDeleteActions={true}
          add={onAddHandler}
          remove={onDeleteHandler}
          getTitle={item => getTitle(item)}
          tabName="add-on"
          tabNameAll="all add-ons"
          children={(field, index, meta) => (
            <AddOnsFields
              field={field}
              index={index}
              meta={meta}
              {...otherProps}
            />
          )}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel={actionLabel || "Next"}
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  addOnsForm: state.form.addOnsForm
});

const mapDispatchToProps = dispatch => ({
  deleteAddOns: id => dispatch(deleteAddOns(id))
});

export default reduxForm({
  form: 'addOnsForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(AddOns));
